let renderHandler

export class DebugRenderer {
  constructor () {
    this.handlers = []
    this.animationFrameId = null

    this.canvas = undefined
    this.context = undefined
  }

  run () {
    window.cancelAnimationFrame(this.animationFrameId)

    renderHandler = this.render.bind(this)
    renderHandler()
  }

  render () {
    this.animationFrameId = window.requestAnimationFrame(renderHandler)
    for (const handler of this.handlers) handler.fn(this.context, this.canvas)
  }
}

const renderer = new DebugRenderer()

export function enableDebugRenderer (canvas) {
  if (process.env.NODE_ENV !== 'development') return

  renderer.handlers = []
  renderer.canvas = canvas
  renderer.context = canvas.getContext('2d')
  renderer.run()
}

export function useDebugRenderer (handler, options) {
  if (process.env.NODE_ENV !== 'development') return

  if (handler) {
    renderer.handlers.push({
      fn: handler,
      options
    })

    renderer.handlers.sort(function (a, b) {
      const aOrder = (a.options && typeof a.options.drawOrder === 'number')
        ? a.options.drawOrder
        : 0
      const bOrder = (b.options && typeof b.options.drawOrder === 'number')
        ? b.options.drawOrder
        : 0
      return aOrder - bOrder
    })
  }

  return [
    renderer.context,
    renderer.canvas
  ]
}
